import EventBus from '@/events/EventBus';
import Events from '@/events/Events';

export default function ($matomo) {
  EventBus.$on(Events.Registered, (params) => {
    $matomo.trackEvent('Registration', Events.Registered, params.type, 100);
  });
}
